import {AfterViewInit, Directive, ElementRef, inject} from '@angular/core';

@Directive({
    selector: '[xuiTextareaAutosize]',
})
export class TextareaAutosizeDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);

  ngAfterViewInit(): void {
    setTimeout(() => {
      const scrollHeight = this.elementRef.nativeElement.scrollHeight;
      const currentStyle = this.elementRef.nativeElement.getAttribute('style');
      this.elementRef.nativeElement.setAttribute('style', currentStyle + ' height:' + (scrollHeight + 20) + 'px;');
    });
  }
}
